(ns client-portal.client.voice-insights.ai-analyst.views
  (:require [client-portal.client.layout :as l]
            [client-portal.client.voice-insights.ai-analyst.data :as ai-analyst.d]
            [shared.core.amelia-light.components.components :as alc]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [shared.core.components.recharts-components :as recharts.c]
            [shared.core.components.recharts.util :as recharts.util]
            [client-portal.client.voice-insights.items.data :as items.d]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [shared.core.router :as router]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(defn build-issue->issue-raw [data]
  (some->> (util/when-not-loading data)
           (mapv (fn [{:keys [issue issue-raw]}]
                   [issue issue-raw]))
           (into {})))

(defn build-x->x-raw [data]
  (some->> (util/when-not-loading data)
           (mapv (fn [{:keys [x x-raw]}]
                   [x x-raw]))
           (into {})))

(defn menu-items-and-bot-issues-card []
  (let [grouping-form-path ai-analyst.d/settings-path
        grouping-form-name :menu-items-and-bot-issues-grouping-value
        selected-grouping @(re/subscribe [:form/val- grouping-form-path grouping-form-name])
        all-data @(re/subscribe [:vi-ai-analyst/data-])
        sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        menu-items-and-bot-issues (some-> (util/when-not-loading all-data)
                                          :menu-items-and-bot-issues
                                          (util/when-not-empty))
        data? (or (util/loading? all-data) menu-items-and-bot-issues)
        {:keys [data top-20-keys]} menu-items-and-bot-issues
        issue->issue-raw (build-issue->issue-raw data)
        chart-data (some->> data
                            (#(if (= selected-grouping "all")
                                %
                                (filterv (fn [{:keys [x]}] (contains? top-20-keys x)) %)))
                            (sort-by :total-count)
                            (reverse)
                            (hash-map :source-key :x
                                      :source-colors items.d/item-color
                                      :target-key :issue
                                      :target-config {:color (tag.d/utterance-tag-name->color "bot-issue")
                                                      :header-description-fn #(tag.d/tag->description
                                                                                {:name "bot-issue"
                                                                                 :value (issue->issue-raw (:name %))})}
                                      :value-key :count
                                      :data)
                            (recharts.util/build-sankey-data))]
    [alc/card {:title "Menu Items by Bot Issue"
               :icon-type :AlertIcon}
     (when (and data? (>= (count top-20-keys) 20))
       [alc/pill-button-group {:selected-value selected-grouping
                               :form-path grouping-form-path
                               :form-name grouping-form-name
                               :options [{:label "Top 20" :value "top-20"}
                                         {:label "All Items" :value "all"}]}])
     (if data?
       [recharts.c/sankey-chart
        {:nodes (:nodes chart-data)
         :links (:links chart-data)
         :link-config {:on-double-click (fn [e {:keys [payload]}]
                                          (let [menu-item (-> payload :source :name)
                                                tag-value (get issue->issue-raw (-> payload :target :name))
                                                fd (sessions.d/filters->query-param
                                                     [{:by "tags"
                                                       :condition "include"
                                                       :join "or"
                                                       :value [{:name "bot-issue"
                                                                :value tag-value}]}
                                                      {:by "menu-items"
                                                       :condition "include"
                                                       :join "or"
                                                       :value [{:name menu-item
                                                                :value menu-item}]}])]
                                            (router/open-route-based-on-event
                                              e
                                              [:vi/sessions nil (assoc sessions-query-params
                                                                  :svm "utterances"
                                                                  :fd fd)])))}
         :tooltip-config {:sort-by-value? true
                          :limit 20
                          :show-double-click-message? true}
         :height (recharts.util/sankey-chart-height chart-data)
         :node-padding 20
         :margin {:left 240 :right 240 :top 20 :bottom 20}}]
       [empty-state/no-chart-data {}])]))

(defn ai-outcomes-and-bot-issues-card []
  (let [grouping-form-path ai-analyst.d/settings-path
        grouping-form-name :ai-outcomes-and-bot-issues-grouping-value
        selected-grouping @(re/subscribe [:form/val- grouping-form-path grouping-form-name])
        all-data @(re/subscribe [:vi-ai-analyst/data-])
        sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        ai-outcomes-and-bot-issues (some-> (util/when-not-loading all-data)
                                           :ai-outcomes-and-bot-issues
                                           (util/when-not-empty))
        data? (or (util/loading? all-data) ai-outcomes-and-bot-issues)
        {:keys [data top-20-keys]} ai-outcomes-and-bot-issues
        issue->issue-raw (build-issue->issue-raw data)
        x->x-raw (build-x->x-raw data)
        chart-data (some->> data
                            (#(if (= selected-grouping "all")
                                %
                                (filterv (fn [{:keys [x-raw]}] (contains? top-20-keys x-raw)) %)))
                            (sort-by :total-count)
                            (reverse)
                            (hash-map :source-key :x
                                      :source-colors items.d/item-color
                                      :source-config {:header-description-fn #(tag.d/tag->description
                                                                                {:name "ai-outcome"
                                                                                 :value (x->x-raw (:name %))})}
                                      :target-key :issue
                                      :target-config {:color (tag.d/utterance-tag-name->color "bot-issue")
                                                      :header-description-fn #(tag.d/tag->description
                                                                                {:name "bot-issue"
                                                                                 :value (issue->issue-raw (:name %))})}
                                      :value-key :count
                                      :data)
                            (recharts.util/build-sankey-data))]
    [alc/card {:title "AI Outcomes by Bot Issue"
               :icon-type :AlertIcon}
     (when (and data? (>= (count top-20-keys) 20))
       [alc/pill-button-group {:selected-value selected-grouping
                               :form-path grouping-form-path
                               :form-name grouping-form-name
                               :options [{:label "Top 20" :value "top-20"}
                                         {:label "All Items" :value "all"}]}])
     (if data?
       [recharts.c/sankey-chart
        {:nodes (:nodes chart-data)
         :links (:links chart-data)
         :link-config {:on-double-click (fn [e {:keys [payload]}]
                                          (let [tag-value1 (get issue->issue-raw (-> payload :target :name))
                                                tag-value2 (get x->x-raw (-> payload :source :name))
                                                fd (sessions.d/filters->query-param
                                                     [{:by "tags"
                                                       :condition "include"
                                                       :join "and"
                                                       :value [{:name "bot-issue"
                                                                :value tag-value1}
                                                               {:name "ai-outcome"
                                                                :value tag-value2}]}])]
                                            (router/open-route-based-on-event
                                              e
                                              [:vi/sessions nil (assoc sessions-query-params
                                                                  :svm "utterances"
                                                                  :fd fd)])))}
         :tooltip-config {:sort-by-value? true
                          :limit 20
                          :show-double-click-message? true}
         :height (recharts.util/sankey-chart-height chart-data)
         :node-padding 20
         :margin {:left 240 :right 240 :top 20 :bottom 20}}]
       [empty-state/no-chart-data {}])]))

(defn ai-escalations-and-bot-issues-card []
  (let [grouping-form-path ai-analyst.d/settings-path
        grouping-form-name :ai-escalations-and-bot-issues-grouping-value
        selected-grouping @(re/subscribe [:form/val- grouping-form-path grouping-form-name])
        all-data @(re/subscribe [:vi-ai-analyst/data-])
        sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        ai-escalations-and-bot-issues (some-> (util/when-not-loading all-data)
                                              :ai-escalations-and-bot-issues
                                              (util/when-not-empty))
        data? (or (util/loading? all-data) ai-escalations-and-bot-issues)
        {:keys [data top-20-keys]} ai-escalations-and-bot-issues
        issue->issue-raw (build-issue->issue-raw data)
        x->x-raw (build-x->x-raw data)
        chart-data (some->> data
                            (#(if (= selected-grouping "all")
                                %
                                (filterv (fn [{:keys [x-raw]}] (contains? top-20-keys x-raw)) %)))
                            (sort-by :total-count)
                            (reverse)
                            (hash-map :source-key :x
                                      :source-colors items.d/item-color
                                      :source-config {:header-description-fn #(tag.d/tag->description
                                                                                {:name "ai-outcome"
                                                                                 :value (x->x-raw (:name %))})}
                                      :target-key :issue
                                      :target-config {:color (tag.d/utterance-tag-name->color "bot-issue")
                                                      :header-description-fn #(tag.d/tag->description
                                                                                {:name "bot-issue"
                                                                                 :value (issue->issue-raw (:name %))})}
                                      :value-key :count
                                      :data)
                            (recharts.util/build-sankey-data))]
    [alc/card {:title "Bot Issue by Escalation Initiator"
               :icon-type :AlertIcon}
     (when (and data? (>= (count top-20-keys) 20))
       [alc/pill-button-group {:selected-value selected-grouping
                               :form-path grouping-form-path
                               :form-name grouping-form-name
                               :options [{:label "Top 20" :value "top-20"}
                                         {:label "All Items" :value "all"}]}])
     (if data?
       [recharts.c/sankey-chart
        {:nodes (:nodes chart-data)
         :links (:links chart-data)
         :link-config {:on-double-click (fn [e {:keys [payload]}]
                                          (let [tag-value1 (get issue->issue-raw (-> payload :target :name))
                                                tag-value2 (get x->x-raw (-> payload :source :name))
                                                fd (sessions.d/filters->query-param
                                                     [{:by "tags"
                                                       :condition "include"
                                                       :join "and"
                                                       :value [{:name "bot-issue"
                                                                :value tag-value1}
                                                               {:name "ai-outcome"
                                                                :value tag-value2}]}])]
                                            (router/open-route-based-on-event
                                              e
                                              [:vi/sessions nil (assoc sessions-query-params
                                                                  :svm "utterances"
                                                                  :fd fd)])))}
         :tooltip-config {:sort-by-value? true
                          :limit 20
                          :show-double-click-message? true}
         :height (recharts.util/sankey-chart-height chart-data)
         :node-padding 20
         :margin {:left 240 :right 240 :top 20 :bottom 20}}]
       [empty-state/no-chart-data {}])]))

(defn root [args]
  (let [data- (re/subscribe [:vi-ai-analyst/data-])]
    (re/create-class
      {:component-did-mount #(re/dispatch [:vi-ai-analyst/initialize])
       :reagent-render
       (fn [args]
         [l/logged-in-with-header-nav-vi
          args
          [:div {:style {:display :flex
                         :flex-direction :column
                         :width "100%"
                         :min-height "100%"
                         :padding "20px 17px 29px"}}
           (if (util/loading? @data-)
             [empty-state/loading-data-card]
             [:div {:style {:flex 1
                            :display :flex
                            :flex-direction :column
                            :gap 12}}
              [menu-items-and-bot-issues-card]
              [ai-outcomes-and-bot-issues-card]
              [ai-escalations-and-bot-issues-card]])]])})))
